<div class="container-fluid top-container">
  <router-outlet></router-outlet>
</div>
